import { VARIANT_PRIMARY, VARIANT_PRIMARY_STRONG, VARIANT_PRIMARY_STAND_ALONE, VARIANT_PRIMARY_STAND_ALONE_STRONG, VARIANT_SECONDARY, VARIANT_SECONDARY_STRONG, VARIANT_SECONDARY_STAND_ALONE, VARIANT_SECONDARY_STAND_ALONE_STRONG, VARIANT_INFO, ELEMENT_TEXT, ELEMENT_ICON, INTERACTION_STATE_ACTIVE, INTERACTION_STATE_HOVER, INTERACTION_STATE_FOCUS_VISIBLE, } from '../../constants';
import { getColor, getOutlineColor, getTextDecorationColor, } from '../../colors/colors.alias';
import { getOutlineWidth, getOutlineStyle, getOutlineOffset, } from '../../borders/borders.alias';
import { constants as Icon } from '../Icon';
import { getFontFamily, getFontSize, getLineHeight, getFontWeight, getTextDecoration, getTextDecorationThickness, getTextUnderlineOffset, } from '../../typography/typography.alias';
export const constants = Object.freeze({
    NAME: 'Link',
    variants: {
        VARIANT_PRIMARY,
        VARIANT_PRIMARY_STRONG,
        VARIANT_PRIMARY_STAND_ALONE,
        VARIANT_PRIMARY_STAND_ALONE_STRONG,
        VARIANT_SECONDARY,
        VARIANT_SECONDARY_STRONG,
        VARIANT_SECONDARY_STAND_ALONE,
        VARIANT_SECONDARY_STAND_ALONE_STRONG,
        VARIANT_INFO,
    },
    elements: {
        ELEMENT_TEXT,
        ELEMENT_ICON,
    },
    interactionStates: {
        INTERACTION_STATE_ACTIVE,
        INTERACTION_STATE_HOVER,
        INTERACTION_STATE_FOCUS_VISIBLE,
    },
});
export default function getLink(transformer, config) {
    const color = getColor(transformer, config);
    const fontFamily = getFontFamily(transformer, config);
    const fontSize = getFontSize(transformer);
    const lineHeight = getLineHeight(transformer);
    const outlineOffset = getOutlineOffset(transformer, config);
    const outlineWidth = getOutlineWidth(transformer, config);
    const outlineColor = getOutlineColor(transformer, config);
    const outlineStyle = getOutlineStyle(transformer, config);
    const fontWeight = getFontWeight(transformer);
    const textDecoration = getTextDecoration(transformer);
    const textDecorationColor = getTextDecorationColor(transformer, config);
    const textDecorationThickness = getTextDecorationThickness(transformer);
    const textUnderlineOffset = getTextUnderlineOffset(transformer);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_ICON]: {
                components: {
                    [Icon.NAME]: {
                        variant: Icon.variants.VARIANT_SMALL,
                    },
                },
                variants: {
                    [VARIANT_PRIMARY]: {
                        styles: {
                            color: color.link.primary.icon.default.value,
                        },
                        interactionStates: {
                            [INTERACTION_STATE_ACTIVE]: {
                                styles: {
                                    color: color.link.primary.icon.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                },
                            },
                            [INTERACTION_STATE_HOVER]: {
                                styles: {
                                    color: color.link.primary.icon.interactionStates[INTERACTION_STATE_HOVER].value,
                                },
                            },
                        },
                    },
                    [VARIANT_SECONDARY]: {
                        styles: {
                            color: color.link.secondary.icon.default.value,
                        },
                        interactionStates: {
                            [INTERACTION_STATE_ACTIVE]: {
                                styles: {
                                    color: color.link.secondary.icon.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                },
                            },
                            [INTERACTION_STATE_HOVER]: {
                                styles: {
                                    color: color.link.secondary.icon.interactionStates[INTERACTION_STATE_HOVER].value,
                                },
                            },
                        },
                    },
                },
            },
            [ELEMENT_TEXT]: {
                styles: {
                    fontSize: fontSize.body.m.value,
                    lineHeight: lineHeight.body.get(fontSize.body.m.value),
                },
                variants: {
                    [VARIANT_PRIMARY]: {
                        styles: {
                            color: color.link.primary.text.default.value,
                            fontFamily: fontFamily.body.value,
                            fontWeight: fontWeight.body.get(fontFamily.body.value),
                            textDecoration: textDecoration.link.primary.text.default.value,
                            textDecorationThickness: textDecorationThickness.link.primary.default.value,
                            textUnderlineOffset: textUnderlineOffset.link.primary.default.value,
                            textDecorationColor: textDecorationColor.link.primary.text.default.value,
                        },
                        interactionStates: {
                            [INTERACTION_STATE_ACTIVE]: {
                                styles: {
                                    color: color.link.primary.text.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecoration: textDecoration.link.primary.text.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecorationThickness: textDecorationThickness.link.primary.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textUnderlineOffset: textUnderlineOffset.link.primary.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecorationColor: textDecorationColor.link.primary.text.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                },
                            },
                            [INTERACTION_STATE_HOVER]: {
                                styles: {
                                    color: color.link.primary.text.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecoration: textDecoration.link.primary.text.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecorationThickness: textDecorationThickness.link.primary.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textUnderlineOffset: textUnderlineOffset.link.primary.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecorationColor: textDecorationColor.link.primary.text.interactionStates[INTERACTION_STATE_HOVER].value,
                                },
                            },
                        },
                    },
                    [VARIANT_PRIMARY_STRONG]: {
                        styles: {
                            color: color.link.primary.text.default.value,
                            fontFamily: fontFamily.link.strong.value,
                            fontWeight: fontWeight.link.strong.get(fontFamily.link.strong.value),
                            textDecoration: textDecoration.link.primaryStrong.text.default.value,
                            textDecorationThickness: textDecorationThickness.link.primaryStrong.default.value,
                            textUnderlineOffset: textUnderlineOffset.link.primaryStrong.default.value,
                            textDecorationColor: textDecorationColor.link.primaryStrong.text.default.value,
                        },
                        interactionStates: {
                            [INTERACTION_STATE_ACTIVE]: {
                                styles: {
                                    color: color.link.primary.text.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecoration: textDecoration.link.primaryStrong.text.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecorationThickness: textDecorationThickness.link.primaryStrong
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textUnderlineOffset: textUnderlineOffset.link.primaryStrong.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecorationColor: textDecorationColor.link.primaryStrong.text
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                },
                            },
                            [INTERACTION_STATE_HOVER]: {
                                styles: {
                                    color: color.link.primary.text.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecoration: textDecoration.link.primaryStrong.text.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecorationThickness: textDecorationThickness.link.primaryStrong
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                    textUnderlineOffset: textUnderlineOffset.link.primaryStrong.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecorationColor: textDecorationColor.link.primaryStrong.text
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                },
                            },
                        },
                    },
                    [VARIANT_PRIMARY_STAND_ALONE]: {
                        styles: {
                            color: color.link.primary.text.default.value,
                            fontFamily: fontFamily.body.value,
                            fontWeight: fontWeight.body.get(fontFamily.body.value),
                            textDecoration: textDecoration.link.primaryStandAlone.text.default.value,
                            textDecorationThickness: textDecorationThickness.link.primaryStandAlone.default.value,
                            textUnderlineOffset: textUnderlineOffset.link.primaryStandAlone.default.value,
                            textDecorationColor: textDecorationColor.link.primaryStandAlone.text.default.value,
                        },
                        interactionStates: {
                            [INTERACTION_STATE_ACTIVE]: {
                                styles: {
                                    color: color.link.primary.text.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecoration: textDecoration.link.primaryStandAlone.text
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecorationThickness: textDecorationThickness.link.primaryStandAlone
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textUnderlineOffset: textUnderlineOffset.link.primaryStandAlone
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecorationColor: textDecorationColor.link.primaryStandAlone.text
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                },
                            },
                            [INTERACTION_STATE_HOVER]: {
                                styles: {
                                    color: color.link.primary.text.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecoration: textDecoration.link.primaryStandAlone.text
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecorationThickness: textDecorationThickness.link.primaryStandAlone
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                    textUnderlineOffset: textUnderlineOffset.link.primaryStandAlone
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecorationColor: textDecorationColor.link.primaryStandAlone.text
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                },
                            },
                        },
                    },
                    [VARIANT_PRIMARY_STAND_ALONE_STRONG]: {
                        styles: {
                            color: color.link.primary.text.default.value,
                            fontFamily: fontFamily.link.strong.value,
                            fontWeight: fontWeight.link.strong.get(fontFamily.link.strong.value),
                            textDecoration: textDecoration.link.primaryStandAloneStrong.text.default.value,
                            textDecorationThickness: textDecorationThickness.link.primaryStandAloneStrong.default
                                .value,
                            textUnderlineOffset: textUnderlineOffset.link.primaryStandAloneStrong.default.value,
                            textDecorationColor: textDecorationColor.link.primaryStandAloneStrong.text.default
                                .value,
                        },
                        interactionStates: {
                            [INTERACTION_STATE_ACTIVE]: {
                                styles: {
                                    color: color.link.primary.text.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecoration: textDecoration.link.primaryStandAloneStrong.text
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecorationThickness: textDecorationThickness.link.primaryStandAloneStrong
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textUnderlineOffset: textUnderlineOffset.link.primaryStandAloneStrong
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecorationColor: textDecorationColor.link.primaryStandAloneStrong.text
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                },
                            },
                            [INTERACTION_STATE_HOVER]: {
                                styles: {
                                    color: color.link.primary.text.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecoration: textDecoration.link.primaryStandAloneStrong.text
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecorationThickness: textDecorationThickness.link.primaryStandAloneStrong
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                    textUnderlineOffset: textUnderlineOffset.link.primaryStandAloneStrong
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecorationColor: textDecorationColor.link.primaryStandAloneStrong.text
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                },
                            },
                        },
                    },
                    [VARIANT_SECONDARY]: {
                        styles: {
                            color: color.link.secondary.text.default.value,
                            fontFamily: fontFamily.body.value,
                            fontWeight: fontWeight.body.get(fontFamily.body.value),
                            textDecoration: textDecoration.link.secondary.text.default.value,
                            textDecorationThickness: textDecorationThickness.link.secondary.default.value,
                            textUnderlineOffset: textUnderlineOffset.link.secondary.default.value,
                            textDecorationColor: textDecorationColor.link.secondary.text.default.value,
                        },
                        interactionStates: {
                            [INTERACTION_STATE_ACTIVE]: {
                                styles: {
                                    color: color.link.secondary.text.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecoration: textDecoration.link.secondary.text.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecorationThickness: textDecorationThickness.link.secondary.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textUnderlineOffset: textUnderlineOffset.link.secondary.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecorationColor: textDecorationColor.link.secondary.text.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                },
                            },
                            [INTERACTION_STATE_HOVER]: {
                                styles: {
                                    color: color.link.secondary.text.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecoration: textDecoration.link.secondary.text.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecorationThickness: textDecorationThickness.link.secondary.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textUnderlineOffset: textUnderlineOffset.link.secondary.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecorationColor: textDecorationColor.link.secondary.text.interactionStates[INTERACTION_STATE_HOVER].value,
                                },
                            },
                        },
                    },
                    [VARIANT_SECONDARY_STRONG]: {
                        styles: {
                            color: color.link.secondary.text.default.value,
                            fontFamily: fontFamily.link.strong.value,
                            fontWeight: fontWeight.link.strong.get(fontFamily.link.strong.value),
                            textDecoration: textDecoration.link.secondaryStrong.text.default.value,
                            textDecorationThickness: textDecorationThickness.link.secondaryStrong.default.value,
                            textUnderlineOffset: textUnderlineOffset.link.secondaryStrong.default.value,
                            textDecorationColor: textDecorationColor.link.secondaryStrong.text.default.value,
                        },
                        interactionStates: {
                            [INTERACTION_STATE_ACTIVE]: {
                                styles: {
                                    color: color.link.secondary.text.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecoration: textDecoration.link.secondaryStrong.text.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecorationThickness: textDecorationThickness.link.secondaryStrong
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textUnderlineOffset: textUnderlineOffset.link.secondaryStrong.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecorationColor: textDecorationColor.link.secondaryStrong.text
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                },
                            },
                            [INTERACTION_STATE_HOVER]: {
                                styles: {
                                    color: color.link.secondary.text.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecoration: textDecoration.link.secondaryStrong.text.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecorationThickness: textDecorationThickness.link.secondaryStrong
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                    textUnderlineOffset: textUnderlineOffset.link.secondaryStrong.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecorationColor: textDecorationColor.link.secondaryStrong.text
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                },
                            },
                        },
                    },
                    [VARIANT_SECONDARY_STAND_ALONE]: {
                        styles: {
                            color: color.link.secondary.text.default.value,
                            fontFamily: fontFamily.body.value,
                            fontWeight: fontWeight.body.get(fontFamily.body.value),
                            textDecoration: textDecoration.link.secondaryStandAlone.text.default.value,
                            textDecorationThickness: textDecorationThickness.link.secondaryStandAlone.default.value,
                            textUnderlineOffset: textUnderlineOffset.link.secondaryStandAlone.default.value,
                            textDecorationColor: textDecorationColor.link.secondaryStandAlone.text.default.value,
                        },
                        interactionStates: {
                            [INTERACTION_STATE_ACTIVE]: {
                                styles: {
                                    color: color.link.secondary.text.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecoration: textDecoration.link.secondaryStandAlone.text
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecorationThickness: textDecorationThickness.link.secondaryStandAlone
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textUnderlineOffset: textUnderlineOffset.link.secondaryStandAlone
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecorationColor: textDecorationColor.link.secondaryStandAlone.text
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                },
                            },
                            [INTERACTION_STATE_HOVER]: {
                                styles: {
                                    color: color.link.secondary.text.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecoration: textDecoration.link.secondaryStandAlone.text
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecorationThickness: textDecorationThickness.link.secondaryStandAlone
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                    textUnderlineOffset: textUnderlineOffset.link.secondaryStandAlone
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecorationColor: textDecorationColor.link.secondaryStandAlone.text
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                },
                            },
                        },
                    },
                    [VARIANT_SECONDARY_STAND_ALONE_STRONG]: {
                        styles: {
                            color: color.link.secondary.text.default.value,
                            fontFamily: fontFamily.link.strong.value,
                            fontWeight: fontWeight.link.strong.get(fontFamily.link.strong.value),
                            textDecoration: textDecoration.link.secondaryStandAloneStrong.text.default
                                .value,
                            textDecorationThickness: textDecorationThickness.link.secondaryStandAloneStrong.default
                                .value,
                            textUnderlineOffset: textUnderlineOffset.link.secondaryStandAloneStrong.default
                                .value,
                            textDecorationColor: textDecorationColor.link.secondaryStandAloneStrong.text.default
                                .value,
                        },
                        interactionStates: {
                            [INTERACTION_STATE_ACTIVE]: {
                                styles: {
                                    color: color.link.secondary.text.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecoration: textDecoration.link.secondaryStandAloneStrong.text
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecorationThickness: textDecorationThickness.link.secondaryStandAloneStrong
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textUnderlineOffset: textUnderlineOffset.link.secondaryStandAloneStrong
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                    textDecorationColor: textDecorationColor.link.secondaryStandAloneStrong.text
                                        .interactionStates[INTERACTION_STATE_ACTIVE].value,
                                },
                            },
                            [INTERACTION_STATE_HOVER]: {
                                styles: {
                                    color: color.link.secondary.text.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecoration: textDecoration.link.secondaryStandAloneStrong.text
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecorationThickness: textDecorationThickness.link.secondaryStandAloneStrong
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                    textUnderlineOffset: textUnderlineOffset.link.secondaryStandAloneStrong
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecorationColor: textDecorationColor.link.secondaryStandAloneStrong.text
                                        .interactionStates[INTERACTION_STATE_HOVER].value,
                                },
                            },
                        },
                    },
                    [VARIANT_INFO]: {
                        styles: {
                            color: color.link.secondary.text.default.value,
                            fontFamily: fontFamily.link.strong.value,
                            fontWeight: fontWeight.link.strong.get(fontFamily.link.strong.value),
                            textDecoration: textDecoration.link.info.text.default.value,
                            textDecorationColor: textDecorationColor.link.info.text.default.value,
                            textDecorationThickness: textDecorationThickness.link.info.default.value,
                            textUnderlineOffset: textUnderlineOffset.link.info.default.value,
                        },
                        interactionStates: {
                            [INTERACTION_STATE_ACTIVE]: {
                                styles: {
                                    color: color.link.secondary.text.interactionStates[INTERACTION_STATE_ACTIVE].value,
                                },
                            },
                            [INTERACTION_STATE_HOVER]: {
                                styles: {
                                    color: color.link.secondary.text.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecoration: textDecoration.link.info.text.interactionStates[INTERACTION_STATE_HOVER].value,
                                    textDecorationColor: textDecorationColor.link.info.text.interactionStates[INTERACTION_STATE_HOVER].value,
                                },
                            },
                        },
                    },
                },
            },
        },
        interactionStates: {
            [INTERACTION_STATE_FOCUS_VISIBLE]: {
                styles: {
                    outlineOffset: outlineOffset.default.value,
                    outlineStyle: outlineStyle.default.value,
                    outlineWidth: outlineWidth.default.value,
                    outlineColor: outlineColor.default.interactionStates[INTERACTION_STATE_FOCUS_VISIBLE].value,
                },
            },
        },
    });
}
